import { render, staticRenderFns } from "./LoginLayout.vue?vue&type=template&id=4796dde4&scoped=true&"
var script = {}
import style0 from "./LoginLayout.vue?vue&type=style&index=0&id=4796dde4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4796dde4",
  null
  
)

export default component.exports